import { HubConnectionState } from '@microsoft/signalr';
import { Row } from '@unistocks/components/layout/flex';
import { Paragraph } from '@unistocks/components/text/text';
import { Tooltip } from '@unistocks/components/tooltip/tooltip';
import { useSignalRHubs, useSignalRStatus } from '@unistocks/shared/signalr/signalr-status';
import React from 'react';
import { Circle, ColorTokens } from 'tamagui';

const HUB_COLORS: Record<HubConnectionState, ColorTokens> = {
  Connected: '$success',
  Disconnected: '$danger',
  Disconnecting: '$danger',
  Connecting: '$warning',
  Reconnecting: '$warning'
};

export const SignalRStatus: React.FC = () => {
  const status = useSignalRStatus();
  const hubs = useSignalRHubs();

  if (!status) return null;

  const color = HUB_COLORS[status];

  return (
    <Tooltip
      label={Object.values(hubs).map(hub => {
        return (
          <Row key={hub.name} gap={'$2'} alignItems="center">
            <Circle size={8} bg={HUB_COLORS[hub.state]} />
            <Paragraph size="$3" textTransform="capitalize">
              {hub.name}: {hub.state}
            </Paragraph>
          </Row>
        );
      })}
    >
      <Circle testID="signalr-status" size={10} bg={color} />
    </Tooltip>
  );
};

SignalRStatus.displayName = 'SignalRStatus';
